import { createPlugin } from '@backstage/core-plugin-api';
import { marketplaceProductExternalRouteRef } from './routes';

export const accessControlPlugin = createPlugin({
  id: 'access-control',
  externalRoutes: {
    marketplaceProductRef: marketplaceProductExternalRouteRef,
  },
});
